import React, { useMemo, useState } from "react";
import Modal from "../../../../shared/modal";
import styles from "./styles.css";
import BackArrow from "./images/close.svg";
import check from "./images/check.svg";
import PropTypes from "prop-types";
import CoveredImage from "./images/verified.svg";
import Cars24PlatinumCoverTheBestModal from "../cars24-platinum-cover-the-best-modal/component";
import toggleArrow from "./images/toggle-arrow.svg";
import { CHECKOUT_FLOW_CMS_SECTIONS } from "../../../../../constants/checkout-constants";
import { DEFAULT_BUNDLE_CONFIG, DEFAULT_SERVICE_CONFIG, DEFAULT_WARRANTY_CONFIG } from "./constants";

const getModalHeading = (planKey, cmsData) => {
    if (planKey === "CAR_SERVICING") {
        return cmsData?.service?.headerTitle || "Car servicing";
    }
    if (planKey === "EXTENDED_WARRANTY_PLAN") {
        return cmsData?.warranty?.headerTitle || "Cars24 Extended Warranty";
    }
    if (planKey === "CAR_COVER_BUNDLES") {
        return cmsData?.bundle?.headerTitle || "Cars24 Car Cover Bundles";
    }
    return "";
};

// eslint-disable-next-line complexity
const getWarrantyCoverCMSData = (cmsConfig = {}) => {
    const cmsSection = (cmsConfig?.pageSections || []).find(
        (section) => section?.pageSection?.name === CHECKOUT_FLOW_CMS_SECTIONS.CHECKOUT_WARRANTY_COVER
    )?.pageSection;
    const parsedData = cmsSection?.meta?.data || {};

    return {
        service: {
            ...DEFAULT_SERVICE_CONFIG,
            ...(parsedData?.service || {})
        },
        warranty: {
            ...DEFAULT_WARRANTY_CONFIG,
            ...(parsedData?.warranty || {})
        },
        bundle: {
            ...DEFAULT_BUNDLE_CONFIG,
            ...(parsedData?.bundle || {})
        }
    };
};

// eslint-disable-next-line complexity
const WarrantyModal = ({ onClose, isOpen, planKey, modalHeading, cmsConfig }) => {
    const [activeTab, setActiveTab] = useState(0);
    const [isWhatIsCoveredModalOpen, setIsWhatIsCoveredModalOpen] = useState(true);

    const cmsData = useMemo(() => getWarrantyCoverCMSData(cmsConfig), [cmsConfig]);

    const normalizedPlanKey = (planKey || "").toUpperCase();
    const normalizedHeading = (modalHeading || "").toUpperCase();
    const isBundle = normalizedPlanKey.includes("BUNDLE") || normalizedHeading.includes("BUNDLE");
    const isServicing = isBundle || normalizedPlanKey.includes("SERVIC") || normalizedHeading.includes("SERVIC");
    const isWarranty = isBundle || normalizedPlanKey.includes("WARRANTY") || normalizedHeading.includes("WARRANTY") || !isServicing;

    const serviceCoveredSection = cmsData?.service?.whatsCovered?.sections?.[0] || {};
    const warrantyCoveredSection = cmsData?.warranty?.whatsCovered?.sections?.[0] || {};
    const warrantyTabs = warrantyCoveredSection?.tabs || [];
    const activeWarrantyTab = warrantyTabs?.[activeTab] || warrantyTabs?.[0] || {};
    const hasWarrantyTabs = warrantyTabs?.length > 0;

    return (
        <Modal shouldCloseOnOverlayClick close={onClose} isOpen={isOpen}>
            <div styleName={"styles.outer"}>
                <div styleName={"styles.headerWrap"}>
                    <p styleName={"styles.heading"}>{modalHeading?.replaceAll("**", "") || getModalHeading(planKey, cmsData)}</p>
                    <img src={BackArrow} alt="See what's covered back arrow" onClick={onClose} />
                </div>
                <div styleName={"styles.wrapper"}>
                    <div styleName={"styles.tabOuter"}>
                        <div styleName={"styles.tabContainer"} onClick={() => setIsWhatIsCoveredModalOpen(!isWhatIsCoveredModalOpen)}>
                            <p styleName={"styles.tabHeading"}><img src={CoveredImage} />{cmsData?.warranty?.whatsCoveredLabel || "What’s covered?"}</p>
                            <img styleName={isWhatIsCoveredModalOpen ? "" : "styles.toggleArrowRotate"} src={toggleArrow} />
                        </div>
                        {isWhatIsCoveredModalOpen && (
                            <React.Fragment>
                                {isBundle && (
                                    <div styleName={"styles.contentWrapper"}>
                                        <p styleName={"styles.contentHeadingOne"}>
                                            <span>1</span>{`${cmsData?.service?.rsaNote || ""} ${cmsData?.service?.rsaNoteSuffix || ""}`.trim()}
                                        </p>
                                    </div>
                                )}
                                {isWarranty && (
                                    <div styleName={"styles.contentWrapper"}>
                                        <p styleName={"styles.contentHeading"}>{warrantyCoveredSection?.title || "Extended warranty cover"}</p>
                                        {hasWarrantyTabs && (
                                            <div styleName={"styles.tabWrapper"}>
                                                {warrantyTabs.map((tab, index) => (
                                                    <div
                                                        key={tab?.label || index}
                                                        styleName={`styles.tab ${activeTab === index ? "styles.tabActive" : ""}`}
                                                        onClick={() => setActiveTab(index)}
                                                    >
                                                        <p styleName={"styles.tabName"}>{tab?.label}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                        <div styleName={"styles.listWrapper"}>
                                            {(activeWarrantyTab?.items || []).map((item) => (
                                                <p key={item} styleName={"styles.list"}>
                                                    <img src={check} alt="Lists check status icon" />
                                                    {item}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {isServicing && (
                                    <div styleName={"styles.contentWrapper"}>
                                        <p styleName={"styles.contentHeading"}>
                                            <span>{isBundle ? "3" : "1"}</span>{serviceCoveredSection?.title || "Car maintenance - Servicing"}
                                        </p>
                                        {(serviceCoveredSection?.items || []).map((item) => (
                                            <p key={item} styleName={"styles.list"}>
                                                <img src={check} alt="Lists check status icon" />
                                                {item}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                    <Cars24PlatinumCoverTheBestModal
                        isServicing={isServicing}
                        isWarranty={isWarranty}
                        isBundle={isBundle}
                        cmsData={cmsData}
                    />
                </div>
            </div>
        </Modal>
    );
};

WarrantyModal.propTypes = {
    onClose: PropTypes.func,
    servicingLocation: PropTypes.string,
    isOpen: PropTypes.bool,
    planKey: PropTypes.string,
    modalHeading: PropTypes.string,
    cmsConfig: PropTypes.object
};

export default WarrantyModal;
